/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Navigation_Audit_DescriptionInputs */



/**
* | output |
* | --- |
* | "Assessment of bridge-team operations, procedures and passage planning." |
*
* @param {Service_Navigation_Audit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_navigation_audit_description = /** @type {((inputs?: Service_Navigation_Audit_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Navigation_Audit_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("评估驾驶台团队作业、程序和航线计划。")
	return /** @type {LocalizedString} */ ("Assessment of bridge-team operations, procedures and passage planning.")
});